import React from 'react'
import type { CalendarEvent } from 'paintscout'
import { ConfirmationDialog, SendEventConfirmationDialog, Typography, useDialogs } from '@paintscout/ui'
import { formatName } from '@paintscout/util/builder'

export function useCancelEventFlow() {
  const { openDialog, dismissDialog, dismissAllDialogs } = useDialogs()

  return (event: CalendarEvent, onDelete: (event: CalendarEvent, template: string | null) => void) => {
    openDialog(ConfirmationDialog, {
      message: 'Are you sure you want to cancel this event?',
      yesLabel: "Yes, I'm sure",
      noLabel: 'Back',
      onConfirm: () => {
        dismissDialog()
        openDialog(SendEventConfirmationDialog, {
          title: 'Send Event Cancellation',
          message: (
            <Typography variant={'body1'}>
              Would you like to notify <strong>{formatName(event.contact)}</strong> of the event cancellation?
            </Typography>
          ),
          missingEmailMessage: !event.contact?.email ? (
            <Typography variant="body1" align="center">
              There is no <strong>email</strong> associated to <strong>{formatName(event.contact)}</strong>, which is
              required to send the event cancellation email.
            </Typography>
          ) : null,
          onConfirm: (send: boolean) => {
            onDelete({ ...event, canceled: true } as CalendarEvent, send ? 'event-cancelled' : null)
            dismissAllDialogs()
          },
          onCancel: () => {
            dismissDialog()
          }
        })
      },
      onCancel: () => {
        dismissDialog()
      }
    })
  }
}
